





















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 *  Component that is used for the input of a space's content.
 */
@Component
export default class SpaceContentInput extends Vue {

    @Prop({ type: String })
    private name!: string;

    @Prop({ type: String })
    private label!: string;

    @Prop({ type: Number })
    private value!: number;

    @Prop({ type: String })
    private unit!: string;

    @Prop({ type: Boolean })
    private error!: boolean;

    /**
     *  Getter and setter to forward the v-model
     *  binding to the input component.
     */
    private get model(): unknown {

        return this.value;

    }

    private set model(value: unknown) {

        this.$emit('input', value);

    }

}
